module.exports = __webpack_public_path__ + "img/A0.e0095c08.png";